// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Translation resources
const resources = {
  bg: {
    translation: {
      home: "Начало",
      favoriteDestinations: "Любими дестинации",
      personalInfo: "Лични данни",
      orderHistory: "История на продажбите",
      kaleiaHeading: "Калея – Автобусни билети",
      fast: "Бързо",
      secure: "Сигурно",
      oneWay: "Еднопосочен",
      twoWay: "Двупосочен",
      departureDate: "Дата на заминаване",
      returnDate: "Дата на връщане",
      from: "От къде",
      to: "До къде",
      search: "Търсене",
      notFoundCities: "Няма намерени градове",
      date: "Дата",
      popularDestination: "Популярни дестинации",
      select: "Избор",
      availableTrips: "Свободни курсове",
      arrival: "Пристигане",
      sector: "Сектор",
      tripDetails: "Направление",
      tripInfo: "Информация за пътуване",
      tripStopsDescription:
        "Часовете на тръгване и пристигане са приблизителни и Калея не носи отговорност за малки закъснения.",
      seatDeparture: "Място Заминаване",
      ticket: "Билет",
      name: "Име",
      email: "Ел. поща",
      phone: "Телефонен номер",
      addToCart: "Добавяне в кошницата",
      successAddTicket: "Успешно добавихте билет в кошницата",
      tickets: "Билети",
      notice: "Важно",
      afterSuccessTicketBuy:
        "След успешно закупуване на билет, системата ще изпрати билетите на посочените от клиента имейл адреси",
      ticketsWillExpire: "Билетите ще са валидни в кошницата за още",
      minutes: "минути",
      payment: "Плащане",
      unsuccessfulPayment: "Неуспешно плащане",
      pleaseCheckFollowingReasons: "Моля, проверете следните възможни причини",
      youCancelPayment:
        "Прекратихте плащането - Прекратихтe процеса на плащaне с карта.",
      unavaibleAmount:
        "Недостатъчна наличност - Проверете дали имате достатъчно средства по сметката.",
      incorrectDetails:
        "Невалидни данни на картата - Уверете се, че сте въвели правилно всички данни на картата, включително номер, срок на валидност и CVV код.",
      techicalProblem:
        "Технически проблем - Възможно е да има временен технически проблем с обработката на плащанията",
      ticketRevalidation: "Управление на билет",
      allRightsReserved: "Всички права запазени",
      termsOfCondition: "Условия на превозвача",
      privacyPolicy: "Политика за поверителност",
      save: "Запазване",
      add: "Добавяне",
      delete: "Изтриване",
      savePersonalInfoDescription:
        "Запазете личните си данни за следващо пътуване",
      foundTicket: "Намери билет",
      ticketNumber: "Номер на билет",
      paste: "Постави",
      lastOrderHistory: "Проследете последните",
      previuseTicketHistory: "предишни покупки на билети",
      resultsNotFound: "Няма намерени резултати",
      seatTwoWayBack: "Моля, изберете час на връщане и запазете своето място",
      seatTwoWayBackHeading: "Място връщане",
      pleaseCheckYourEmail:
        "Моля, проверете своята електронна поща за информация относно билетите",
      successfulPayment: "Успешно плащане",
      destination: "Дестинация",
      dateAndHour: "Дата и час",
      place: "Място",
      price: "Цена",
      downloadTicket: "Изтегли билет",
      fillEmptyFields: "Моля, попълнете всички празни полета",
      back: "Назад",
      departure: "Заминаване",
      return: "Връщане",
      returnTime: "Час на връщане",
      lv: "лв",
      pleaseSelectReturnTime: "Моля, изберете час на връщане",
      noScheduleFound: "Няма наличен курс",
      forReturnTime: "за връщане на избраната дата",
      busTimeExpire: "Часът за тръгване на автобуса вече е изтекъл",
      pleaseCheckAvailable: "Моля, проверете следващите налични курсове",
      plaeseAddValidEmail: "Моля, въведете валидна Ел.поща",
      chooseDestinatonText:
        "Изберете своя маршрут и закупете билета си само с няколко клика",
      destinationAlreadyExist: "Тази дестинация вече съществува",
      pleaseAddFavoriteDestinations: "Моля, добавете любими дестинации",
      yes: "Да",
      no: "Не",
      sureToDelete: "Желаете ли да изтриете дестинацията?",
      notFoundPage: "За съжаление страницата, която сте посетили не съществува",
      successSave: "Успешно запазване",
      wrongEmailOrPhone: "Грешен имейл или телефонен номер",
      pleaseCheckAgainTicketNumber: "Моля, проверете отново номера на билета",
      emailOrPhoneVerification:
        "За да завършите процеса на верификация, моля, потвърдете своята самоличност чрез имейл и телефонен номер.",
      confirmation: "Потвърждаване",
      emailFromTicket: "Имейл от билета",
      phoneFromTicket: "Телефонен номер от билета",
      pleaseSelectSchedule: "Моля, изберете курс",
      pleaseSelect: "Изберете",
      inBusAndChooseNewDetails:
        "в автобуса и презаверете билета с новите данни",
      revalidateTheTicket: "Презавери билета",
      pleaseFillTicketNumber: "Моля, попълнете номера на билета",
      chooseNewDate: "Изберете нова дата",
      foundFreeSchedule: "Намери свободни курсове",
      notFoundForThisDate:
        "За избраната дата и градове не са намерени налични резултати",
      problemOccurred: "Възникна проблем",
      sessionExpired: "Сесията ви е изтекла, моля рестартирайте приложението",
      seatAlreadyReserved: "Това място е вече резервирано",
      wrongTicketNumber: "Грешен номер на билет",
      successfullChange: "Успешна промяна",
      unsuccessfullChange: "Неуспешна промяна",
      maxTicket: "Максималният брой за този билет е надвишен",
      noTicketsFound: "Няма добавени билети",
      freeSeatPlace: "Свободни места",
      termsOfUseIntro: [
        "„Калея“ ООД, със седалище и адрес на управление: гр. София, ул. „Струга“ № 5А, е лицензиран превозвач, притежаващ Лиценз № 0005 за международен автомобилен превоз на пътници.",
        "Настоящите Общи условия уреждат основните правила за ползване на предлаганите от „Калея“ ООД транспортни услуги, включително условията за закупуване и анулиране на билети, неявяване, превоз на багаж и домашни любимци, правилата за поведение по време на пътуване и правата и задълженията на пътниците и Превозвача.",
        "„Калея“ ООД се стреми да осигурява на своите клиенти безопасно, комфортно и приятно пътуване. Компанията разполага със съвременни автобуси, отговарящи на приложимите европейски изисквания и стандарти за пътнически транспорт. Превозите се извършват от квалифицирани и опитни водачи.",
      ],
      termsOfUseSections: [
        {
          heading: "1. Анулиране на билет от страна на пътника",
          content: [
            "За анулиране на билет се счита отказът на пътника от пътуването преди планираната дата и час на отпътуване, при условие че билетът не е бил използван.",
            "Размерът на възстановената сума зависи от момента, в който е направено анулирането:",
            [
              "При анулиране повече от 72 часа преди отпътуването – удържат се 10% от стойността на билета и се възстановяват 90%.",
              "При анулиране между 72 и 24 часа преди отпътуването – удържат се 50% от стойността на билета и се възстановяват 50%.",
              "При анулиране по-малко от 24 часа преди отпътуването – удържат се 100% от стойността на билета и сума не се възстановява.",
            ],
            {
              subheading: "Анулиране на билет, закупен онлайн",
            },
            "За анулиране на билет, закупен онлайн, пътникът трябва да изпрати имейл на:",
            "refund@kaleiatravel.com",
            "Имейлът трябва да съдържа:",
            [
              "PDF файла на закупения билет;",
              "датата, на която е направена покупката;",
              "последните 4 цифри на банковата карта, използвана за плащането;",
              "изрично заявление, че пътникът желае билетът да бъде анулиран.",
            ],
            "Когато съгласно настоящите Общи условия се дължи възстановяване на сума, тя се възстановява по банковата карта, с която е извършено първоначалното плащане.",
          ],
        },
        {
          heading: "2. Неявяване за пътуване",
          content: [
            "За неявяване се счита както физическото отсъствие на пътника към момента на отпътуване, така и пристигането му на мястото за качване след потеглянето на автобуса.",
            "При неявяване стойността на билета не се възстановява.",
            "Пътникът носи отговорност да бъде на посоченото място за качване достатъчно време преди обявения час на отпътуване.",
            "Препоръчително е пътниците да бъдат на мястото за качване най-малко 15 минути преди обявения час на отпътуване.",
          ],
        },
        {
          heading: "3. Правила за поведение и право на отказ от превоз",
          content: [
            "Всеки пътник е длъжен да спазва обществения ред и да не създава опасност, неудобство или смущение за останалите пътници, водачите и другите членове на екипажа.",
            "„Калея“ ООД си запазва правото да откаже качване или да прекрати пътуването на пътник, включително когато той притежава валиден билет, ако пътникът:",
            [
              "е под видимо влияние на алкохол, наркотични или други упойващи вещества;",
              "проявява агресивно, заплашително, обидно или непристойно поведение;",
              "нарушава обществения ред;",
              "застрашава безопасността, здравето или комфорта на останалите пътници или екипажа;",
              "поврежда или създава опасност от повреждане на превозното средство;",
              "отказва да изпълнява разумни указания на водача или представител на Превозвача, свързани с безопасността и нормалното протичане на пътуването;",
              "с поведението си възпрепятства нормалното извършване на превоза.",
            ],
            "При отказ от превоз или прекратяване на пътуването поради поведение на пътника, попадащо в някоя от горните хипотези, стойността на билета не се възстановява, освен когато приложимото законодателство предвижда друго.",
            "Превозвачът има право да предприеме необходимите действия за осигуряване на безопасността и спокойствието на всички пътници и екипажа.",
          ],
        },
        {
          heading: "4. Билет и документи за пътуване",
          content: [
            "Всеки пътник е длъжен да разполага с валиден билет за съответното пътуване.",
            "Билет, закупен онлайн, може да бъде представен в електронен или разпечатан вид при поискване от водача или друг представител на Превозвача.",
            "Пътникът носи отговорност за наличието и валидността на всички лични и други документи, необходими за извършване на съответното пътуване.",
            "При международни пътувания пътникът е длъжен да разполага с валиден документ за самоличност и, когато е приложимо, с виза, разрешение за пребиваване, декларации, разрешения за пътуване на непълнолетни лица и всички други документи, изисквани от държавите по маршрута.",
            "Превозвачът не носи отговорност за невъзможност на пътник да премине държавна граница поради липсващи, невалидни или неподходящи документи.",
          ],
        },
        {
          heading: "5. Багаж",
          content: [
            "В цената на стандартния билет е включен:",
            [
              "1 брой ръчен багаж в салона на автобуса – до 5 кг и с максимални размери 35 × 35 × 20 см;",
              "1 брой багаж в багажното отделение – до 10 кг и с максимални размери 80 × 50 × 30 см.",
            ],
            "Допълнителният багаж следва, когато е възможно, да бъде предварително заявен пред Превозвача.",
            "Всяка допълнителна багажна единица се таксува с 3 евро срещу задължително издаване на фискален бон.",
            "Заплащането на такса за допълнителен багаж не гарантира неговото приемане, ако липсва достатъчно свободно пространство в багажното отделение.",
            "Превозвачът има право да откаже приемането на допълнителен или извънгабаритен багаж при липса на достатъчно място или когато неговите размери, тегло, съдържание или състояние могат да създадат опасност, да повредят автобуса или друг багаж или да причинят сериозно неудобство на останалите пътници.",
            "Пътникът носи отговорност багажът му да бъде подходящо опакован и затворен.",
          ],
        },
        {
          heading: "6. Забранени предмети и вещества",
          content: [
            "Не се допуска превозването в салона или багажното отделение на предмети и вещества, чието притежание или транспортиране е забранено от закона или които могат да създадат опасност за пътниците, екипажа, превозното средство или останалия багаж.",
            "Не се допуска превозването на леснозапалими, взривоопасни, токсични, корозивни, радиоактивни или други опасни вещества, освен когато тяхното транспортиране е изрично разрешено от приложимото законодателство и предварително съгласувано с Превозвача.",
            "Превозвачът има право да откаже превозването на багаж или предмет, за който има основателно съмнение, че представлява опасност или нарушава приложимите законови изисквания.",
          ],
        },
        {
          heading: "7. Превоз на домашни любимци",
          content: [
            "Превозът на домашни любимци с тегло до 8 кг е разрешен при спазване на следните условия:",
            [
              "за домашния любимец се закупува билет на стойност 50% от цената на редовния билет за съответното пътуване;",
              "домашният любимец трябва да бъде с тегло до 8 кг;",
              "животното задължително трябва да бъде поставено в подходяща клетка, транспортна чанта, сак или друг предназначен за целта безопасен транспортен контейнер;",
              "домашният любимец трябва да остане в транспортния контейнер по време на пътуването;",
              "транспортният контейнер трябва да бъде поставен на пода непосредствено до мястото на пътника;",
              "транспортният контейнер не може да бъде поставян върху седалка;",
              "животното и транспортният контейнер не трябва да възпрепятстват пътеката, аварийните изходи или движението на останалите пътници;",
              "собственикът носи отговорност за поведението, хигиената и безопасността на домашния любимец по време на цялото пътуване.",
            ],
            "Домашни любимци с тегло над 8 кг не се приемат за превоз, освен ако Превозвачът предварително и изрично не е дал съгласие за конкретното пътуване.",
            "Превозвачът си запазва правото да откаже превозването на домашен любимец, когато изискванията на настоящия раздел не са изпълнени или когато животното създава реална опасност или сериозно неудобство за останалите пътници.",
            "При международни пътувания собственикът носи пълна отговорност за наличието на всички необходими документи, паспорти, ваксинации, микрочипове и други изисквания за преминаване през съответните държави и граници.",
          ],
        },
        {
          heading: "8. Пътуване на деца",
          content: [
            "Деца, които не са навършили 14-годишна възраст, пътуват задължително с придружител.",
            "Родителят, настойникът или придружителят носи отговорност за наличието на всички документи, декларации и разрешения, необходими за пътуването на детето, включително при международни пътувания.",
          ],
        },
        {
          heading: "9. Разписание, маршрут и спирки",
          content: [
            "„Калея“ ООД полага необходимите усилия за спазване на публикуваното разписание.",
            "Обявените часове на пристигане могат да бъдат повлияни от пътната обстановка, задръствания, пътнотранспортни произшествия, гранични и митнически проверки, метеорологични условия, временни ограничения на движението и други обстоятелства извън непосредствения контрол на Превозвача.",
            "При необходимост и когато това се налага поради обективни обстоятелства, Превозвачът може временно да промени маршрут, място на качване или слизане или междинна спирка.",
            "Когато промяната е предварително известна и е съществена за пътуването, Превозвачът полага разумни усилия да информира засегнатите пътници своевременно чрез предоставените от тях данни за контакт или чрез каналите за информация на дружеството.",
            "Настоящият раздел не ограничава правата на пътниците, предоставени им от приложимото законодателство.",
          ],
        },
        {
          heading: "10. Отмяна или значително закъснение на пътуване",
          content: [
            "Когато пътуване бъде отменено или се очаква значително закъснение на отпътуването, „Калея“ ООД информира засегнатите пътници възможно най-скоро, доколкото разполага с актуални данни за контакт с тях.",
            "При случаите и условията, при които приложимото законодателство предвижда това, на пътника се предоставя избор между:",
            [
              "продължаване на пътуването или пренасочване до крайната дестинация при съпоставими условия и при първа възможност; или",
              "възстановяване на съответната стойност на билета.",
            ],
            "Когато автобусът стане технически неизправен по време на пътуването, Превозвачът предприема разумните и изискуеми от закона действия за продължаване на превоза, осигуряване на заместващо превозно средство или транспортиране на пътниците до място, от което пътуването може да бъде продължено.",
            "Когато съгласно приложимото европейско или национално законодателство пътникът има право на допълнителна помощ, възстановяване на суми или обезщетение при отмяна или закъснение, тези права се прилагат независимо от настоящите Общи условия.",
          ],
        },
        {
          heading: "11. Обстоятелства извън контрола на Превозвача",
          content: [
            "Превозвачът не може да гарантира точно време на пристигане при наличие на обстоятелства, върху които няма разумен контрол, включително тежък трафик, пътни инциденти, затваряне на пътища, гранични проверки, стачки, тежки метеорологични условия, природни бедствия, действия на държавни органи или други извънредни обстоятелства.",
            "При възникване на такива обстоятелства Превозвачът полага разумни усилия за ограничаване на последиците за пътниците.",
            "Този раздел не изключва и не ограничава права, които не могат да бъдат ограничени съгласно приложимото законодателство.",
          ],
        },
        {
          heading: "12. Пътници с увреждания или намалена подвижност",
          content: [
            "„Калея“ ООД не допуска дискриминация на пътници поради увреждане или намалена подвижност.",
            "Пътник, който има нужда от специална помощ, следва да уведоми Превозвача предварително и в разумен срок преди пътуването, за да може да бъде направена необходимата организация, доколкото това е възможно.",
            "Превозвачът оказва необходимото съдействие съобразно приложимото законодателство, техническите характеристики на използваното превозно средство и конкретните условия на пътуването.",
          ],
        },
        {
          heading: "13. Забравени и изгубени вещи",
          content: [
            "Пътниците са длъжни да полагат необходимата грижа за личните си вещи по време на пътуването и при слизане от автобуса.",
            "При установяване на забравена вещ пътникът следва възможно най-скоро да се свърже с „Калея“ ООД и да предостави информация за:",
            [
              "датата и маршрута на пътуването;",
              "номера или други данни от билета, когато са налични;",
              "подробно описание на изгубената вещ;",
              "контакт за обратна връзка.",
            ],
            "Намерени вещи се съхраняват от Превозвача за разумен период съобразно естеството им и приложимите изисквания.",
            "Разходите за изпращане или предаване на намерена вещ извън обичайното място за получаване могат да бъдат за сметка на нейния собственик.",
          ],
        },
        {
          heading: "14. Жалби, сигнали и рекламации",
          content: [
            "Пътниците могат да подават жалби, сигнали и рекламации относно предоставяните от „Калея“ ООД транспортни услуги на:",
            "office@kaleiatravel.com",
            "Жалбата следва да съдържа достатъчно информация за идентифициране на конкретното пътуване и възникналия проблем, включително дата, маршрут, данни за билета и контакти за обратна връзка, когато са налични.",
            "За случаите, попадащи в приложното поле на Регламент (ЕС) № 181/2011, жалба във връзка с правата по Регламента може да бъде подадена в срок до 3 месеца от датата, на която редовната услуга е била извършена или е трябвало да бъде извършена.",
            "„Калея“ ООД разглежда постъпилите жалби и предоставя отговор в сроковете, установени от приложимото законодателство.",
          ],
        },
        {
          heading: "15. Безопасност по време на пътуването",
          content: [
            "Пътниците са длъжни да спазват всички указания на водача и представителите на Превозвача, свързани с безопасността по време на пътуването.",
            "Когато автобусът е оборудван с предпазни колани, пътниците следва да ги използват в съответствие с приложимите изисквания.",
            "Не се допуска поведение, което може да разсее водача, да попречи на безопасното управление на превозното средство или да създаде риск за останалите пътници.",
            "Не се допуска блокиране на пътеките, вратите и аварийните изходи.",
          ],
        },
        {
          heading: "16. Приложимо законодателство и права на пътниците",
          content: [
            "Настоящите Общи условия се прилагат заедно с действащото българско и европейско законодателство в областта на автомобилния превоз на пътници и защитата на потребителите.",
            "Когато разпоредба на настоящите Общи условия противоречи на императивна разпоредба на приложимото законодателство, прилага се съответната законова разпоредба.",
            "Настоящите Общи условия не ограничават законови права на пътниците, които не могат да бъдат изключени или ограничени по договорен път.",
            "Със закупуването на билет пътникът потвърждава, че е имал възможност да се запознае с настоящите Общи условия.",
            "С използването на транспортната услуга пътникът се задължава да спазва приложимите правила за безопасност и поведение по време на пътуването.",
          ],
        },
      ],
      policyPrivacyHeading:
        "Тази политика за поверителност описва как ”Калея” ООД, с адрес на  управление гр. София, ул. Струга 5А, лицензиран оператор, притежаващ Лиценз за международен превоз на пътници с номер 0005 събира, използва и защитава личните данни на потребителите на нашата система за продажба на автобусни билети. Ние се ангажираме да защитаваме вашата лична информация и да спазваме Общия регламент за защита на данните (GDPR).",
      policyPrivacyFirstHeading: "1. Събиране на информация",
      policyPrivacyFirstDescription:
        "Ние събираме следната информация: Име, Фамилия, Имейл адрес, Телефонен номер, Платежна информация (само за целите на транзакциите), Информация за пътуването (дата, час, дестинация)",
      policyPrivacySecondHeading: "2. Правно основание за обработка",
      policyPrivacySecondDescription:
        "Ние обработваме вашите лични данни на следните основания: Изпълнение на договор Законово задължение Легитимен интерес Вашето съгласие",
      policyPrivacyThirdHeading: "3. Използване на информацията",
      policyPrivacyThirdDescription:
        "Събраната информация се използва за: Обработка на покупки и резервации Изпращане на потвърждения и актуализации Подобряване на нашите услуги Обслужване на клиенти",
      policyPrivacyFourHeading: "4. Споделяне на информацията",
      policyPrivacyFourDescription:
        "Ние не споделяме личните данни на потребителите с трети страни, освен ако това не е необходимо за: Обработка на платежни транзакции Спазване на законови изисквания Защита на нашите права и собственост ",
      policyPrivacyFiveHeading: "5. Защита на информацията ",
      policyPrivacyFiveDescription:
        "Ние използваме разнообразни мерки за сигурност, за да гарантираме защитата на личните данни, включително: Шифроване на данните Ограничен достъп до данните Редовни проверки на системите за сигурност ",
      policyPrivacySixHeading: "6. Права на потребителите ",
      policyPrivacySixDescription:
        "Потребителите имат право да: Достъпват личните си данни Коригират личните си данни Изтриват личните си данни (право да бъдете забравени) Ограничат обработката на личните си данни Преносимост на данните Възразят срещу обработката на данните Откажат автоматизирани решения и профилиране",
      policyPrivacySevenHeading: "7. Запазване на данни",
      policyPrivacySevenDescription:
        "Ние съхраняваме личните данни толкова дълго, колкото е необходимо за изпълнение на целите, за които са събрани, включително за спазване на правни, счетоводни или отчетни изисквания.",
      policyPrivacyEightHeading: "8. Трансфер на данни ",
      policyPrivacyEightDescription:
        "Личните ви данни могат да бъдат прехвърлени и съхранявани извън Европейското икономическо пространство (ЕИП). В такива случаи ще предприемем всички необходими мерки, за да осигурим адекватно ниво на защита.",
      policyPrivacyNineHeading: "9. Уведомление за нарушение на данни",
      policyPrivacyNineDescription:
        "В случай на нарушение на сигурността на личните данни, ние ще уведомим засегнатите лица и компетентните органи в съответствие с GDPR.",
      policyPrivacyTenHeading: "10. Контакт",
      policyPrivacyTenDescription:
        "Ако имате въпроси или притеснения относно тази политика за поверителност, моля, свържете се с нас на: Имейл: office@kaleiatravel.com Телефон: +359 894 77 44 40 +359 2 832 10 88",
      policyPrivacyElevenHeading: "11. Промени в политиката за поверителност",
      policyPrivacyElevenDescription:
        "Ние си запазваме правото да актуализираме тази политика за поверителност по всяко време. Промените ще бъдат публикувани на нашия уебсайт и ще влязат в сила веднага след тяхното публикуване.",
      remove: "Премахване",
      expireTicketsInCart:
        "Билетите ви са изтекли. Моля, добавете ги отново, за да завършите покупката.",
      pleaseSelectOtherDateTwoWay: "Моля, изберете друга дата за връщане",
      emptyInputs: "Непопълнени полета",
    },
  },
  en: {
    translation: {
      home: "Home",
      favoriteDestinations: "Favorite Destinations",
      personalInfo: "Personal Details",
      orderHistory: "Order History",
      kaleiaHeading: "Kaleia bus tickets",
      fast: "Fast",
      secure: "Secure",
      oneWay: "One – Way",
      twoWay: "Two – Way",
      departureDate: "Departure Date",
      returnDate: "Return Date",
      from: "From",
      to: "To",
      search: "Search",
      notFoundCities: "Cities not found",
      date: "Date",
      popularDestination: "Popular Destination",
      select: "Select",
      availableTrips: "Available trips",
      departure: "Departure",
      arrival: "Arrival",
      sector: "Platform",
      tripDetails: "Trip Details",
      tripInfo: "Trip Details",
      tripStopsDescription:
        'Times of arrival in the cities, which are past the departure point are approximate. "Kaleia" is not responsible for delays caused by worsened traffic, weather conditions or other external factors.',
      seatDeparture: "Select seat for departure trip",
      ticket: "Ticket",
      name: "Name",
      email: "E-Mail",
      phone: "Phone Number",
      addToCart: "Add to cart",
      successAddTicket: "Ticket added to cart",
      tickets: "Tickets",
      notice: "Notice",
      afterSuccessTicketBuy:
        "After a successful payment, you will receive your tickets on via email",
      ticketsWillExpire: "Your ticket will be active in your cart for another",
      minutes: "minutes",
      payment: "Payment",
      unsuccessfulPayment: "Payment Unsuccessful",
      pleaseCheckFollowingReasons:
        "Your payment was unsuccessful for any of the following reasons:",
      youCancelPayment: "You cancelled the payment proccess",
      unavaibleAmount:
        "Insufficient funds – Please make sure that you have the listed amount available in your card",
      incorrectDetails:
        "Wrong card details – Please make sure that you have given the correct card number, validity date and CVV",
      techicalProblem:
        "Technical problem – It is possible there might be a technical issue. You can try again at a later time or by using a different card",
      ticketRevalidation: "Ticket management",
      allRightsReserved: "All rights reserved",
      termsOfCondition: "Terms of service",
      privacyPolicy: "Privacy policy",
      save: "Save",
      add: "Add",
      delete: "Delete",
      savePersonalInfoDescription:
        "Save your personal details for your next trip",
      foundTicket: "Search for ticket",
      ticketNumber: "Ticket number",
      paste: "Paste",
      lastOrderHistory: "Track the latest",
      previuseTicketHistory: "previous ticket purchases",
      resultsNotFound: "No results found",
      seatTwoWayBack: "Please select a return time and reserve your seat.",
      seatTwoWayBackHeading: "Return seat",
      pleaseCheckYourEmail: "Please check your email for ticket information.",
      successfulPayment: "Successful payment",
      destination: "Destination",
      dateAndHour: "Date and time",
      place: "Seat",
      price: "Price",
      downloadTicket: "Download ticket",
      fillEmptyFields: "Please fill the empty fields",
      back: "Back",
      return: "Return",
      returnTime: "Return time",
      lv: "BGN",
      pleaseSelectReturnTime: "Please select a return time",
      noScheduleFound: "No schedule available",
      forReturnTime: "to return the selected date",
      busTimeExpire: "The bus departure time has already passed",
      pleaseCheckAvailable: "Please check the next available courses",
      plaeseAddValidEmail: "Please enter a valid email",
      chooseDestinatonText:
        "Choose your route and purchase your ticket in just a few clicks",
      destinationAlreadyExist: "This destination already exists",
      pleaseAddFavoriteDestinations: "Please add favorite destinations",
      yes: "Yes",
      no: "No",
      sureToDelete: "Do you want to delete the destination?",
      notFoundPage: "Unfortunately, the page you visited does not exist",
      successSave: "Saved successfully",
      wrongEmailOrPhone: "Incorrect email or phone number",
      pleaseCheckAgainTicketNumber: "Please check the ticket number again",
      emailOrPhoneVerification:
        "To complete the verification process, please confirm your identity via email and phone number",
      confirmation: "Confirm",
      emailFromTicket: "Ticket email",
      phoneFromTicket: "Phone number from ticket",
      pleaseSelectSchedule: "Please select schedule",
      pleaseSelect: "Please select",
      inBusAndChooseNewDetails:
        "on the bus and revalidate the ticket with the new details",
      revalidateTheTicket: "Revalidate the ticket",
      pleaseFillTicketNumber: "Please fill in the ticket number",
      chooseNewDate: "Select new date",
      foundFreeSchedule: "Find available schedule",
      notFoundForThisDate:
        "No available results found for the selected date and cities.",
      problemOccurred: "A problem occurred",
      sessionExpired:
        "Your session has expired, please restart the application",
      seatAlreadyReserved: "This place is already booked",
      wrongTicketNumber: "Wrong ticket number",
      successfullChange: "Successful change",
      unsuccessfullChange: "Unsuccessful change",
      maxTicket: "The maximum number for this ticket has been exceeded",
      noTicketsFound: "No tickets added",
      freeSeatPlace: "Free seats",
      termsOfUseIntro: [
        "Kaleia Ltd., with registered office and management address at 5A Struga Street, Sofia, Bulgaria, is a licensed passenger transport operator holding International Passenger Transport Licence No. 0005.",
        "These General Terms and Conditions govern the main rules for the use of the transport services provided by Kaleia Ltd., including ticket purchase and cancellation, no-shows, luggage and pet transport, passenger conduct during travel, and the rights and obligations of passengers and the Carrier.",
        "Kaleia Ltd. aims to provide its customers with safe, comfortable and pleasant travel. The company operates modern coaches that comply with the applicable European requirements and standards for passenger transport. Services are carried out by qualified and experienced drivers.",
      ],
      termsOfUseSections: [
        {
          heading: "1. Ticket Cancellation by the Passenger",
          content: [
            "A ticket cancellation means that the passenger withdraws from the journey before the scheduled date and time of departure, provided that the ticket has not been used.",
            "The amount refunded depends on when the cancellation is made:",
            [
              "If cancelled more than 72 hours before departure – 10% of the ticket price is retained and 90% is refunded.",
              "If cancelled between 72 and 24 hours before departure – 50% of the ticket price is retained and 50% is refunded.",
              "If cancelled less than 24 hours before departure – 100% of the ticket price is retained and no refund is due.",
            ],
            {
              subheading: "Cancellation of a Ticket Purchased Online",
            },
            "To cancel a ticket purchased online, the passenger must send an email to:",
            "refund@kaleiatravel.com",
            "The email must contain:",
            [
              "the PDF file of the purchased ticket;",
              "the date on which the purchase was made;",
              "the last four digits of the bank card used for payment;",
              "an explicit statement that the passenger wishes to cancel the ticket.",
            ],
            "Where a refund is due under these General Terms and Conditions, the amount will be refunded to the bank card used for the original payment.",
          ],
        },
        {
          heading: "2. No-Show Policy",
          content: [
            "A no-show includes both the physical absence of the passenger at the time of departure and the passenger arriving at the boarding point after the coach has already departed.",
            "In the event of a no-show, the ticket price is not refunded.",
            "Passengers are responsible for arriving at the designated boarding point sufficiently in advance of the scheduled departure time.",
            "Passengers are advised to be at the boarding point at least 15 minutes before the scheduled departure time.",
          ],
        },
        {
          heading: "3. Passenger Conduct and Right to Refuse Carriage",
          content: [
            "All passengers are required to observe public order and must not create danger, disturbance or unreasonable inconvenience to other passengers, drivers or other members of the crew.",
            "Kaleia Ltd. reserves the right to refuse boarding or terminate the journey of a passenger, even where that passenger holds a valid ticket, if the passenger:",
            [
              "is visibly under the influence of alcohol, narcotics or other intoxicating substances;",
              "behaves aggressively, threateningly, abusively or indecently;",
              "disturbs public order;",
              "endangers the safety, health or comfort of other passengers or the crew;",
              "damages or creates a risk of damage to the vehicle;",
              "refuses to comply with reasonable instructions given by the driver or another representative of the Carrier relating to safety or the proper conduct of the journey;",
              "otherwise interferes with the normal provision of the transport service.",
            ],
            "Where carriage is refused or a passenger's journey is terminated due to conduct falling within any of the circumstances listed above, the ticket price will not be refunded, unless otherwise required by applicable law.",
            "The Carrier is entitled to take the necessary measures to ensure the safety and comfort of all passengers and crew members.",
          ],
        },
        {
          heading: "4. Tickets and Travel Documents",
          content: [
            "Every passenger must hold a valid ticket for the relevant journey.",
            "A ticket purchased online may be presented either electronically or in printed form when requested by the driver or another representative of the Carrier.",
            "Passengers are responsible for ensuring that they possess all valid personal and other documents required for the relevant journey.",
            "For international travel, passengers must hold a valid identity document and, where applicable, a visa, residence permit, parental declaration, travel authorisation for minors and any other documents required by the countries along the route.",
            "The Carrier shall not be responsible where a passenger is unable to cross a state border due to missing, invalid or otherwise insufficient travel documents.",
          ],
        },
        {
          heading: "5. Luggage",
          content: [
            "The standard ticket price includes:",
            [
              "1 item of hand luggage carried inside the passenger compartment – up to 5 kg and with maximum dimensions of 35 × 35 × 20 cm;",
              "1 item of luggage carried in the luggage compartment – up to 10 kg and with maximum dimensions of 80 × 50 × 30 cm.",
            ],
            "Additional luggage should, where possible, be declared to the Carrier in advance.",
            "Each additional item of luggage is charged at EUR 3, with a fiscal receipt issued for the payment.",
            "Payment of the additional luggage fee does not guarantee acceptance of the luggage where there is insufficient available space in the luggage compartment.",
            "The Carrier reserves the right to refuse additional or oversized luggage where there is insufficient space or where, due to its dimensions, weight, contents or condition, it may create a safety risk, damage the vehicle or other luggage, or cause serious inconvenience to other passengers.",
            "Passengers are responsible for ensuring that their luggage is appropriately packed and securely closed.",
          ],
        },
        {
          heading: "6. Prohibited Items and Substances",
          content: [
            "Items and substances whose possession or transport is prohibited by law, or which may present a danger to passengers, crew, the vehicle or other luggage, may not be carried inside the passenger compartment or the luggage compartment.",
            "The transport of flammable, explosive, toxic, corrosive, radioactive or other hazardous substances is prohibited unless their transport is expressly permitted by applicable law and has been agreed with the Carrier in advance.",
            "The Carrier reserves the right to refuse carriage of any luggage or item where there are reasonable grounds to believe that it presents a danger or breaches applicable legal requirements.",
          ],
        },
        {
          heading: "7. Transport of Pets",
          content: [
            "Pets weighing up to 8 kg are permitted subject to the following conditions:",
            [
              "a ticket must be purchased for the pet at 50% of the regular passenger fare for the relevant journey;",
              "the pet must weigh no more than 8 kg;",
              "the animal must be placed in a suitable cage, pet carrier, transport bag or another safe container designed for animal transport;",
              "the pet must remain inside the transport container throughout the journey;",
              "the transport container must be placed on the floor immediately next to the passenger's seat;",
              "the transport container may not be placed on a passenger seat;",
              "the animal and its transport container must not obstruct the aisle, emergency exits or the movement of other passengers;",
              "the owner is responsible for the behaviour, hygiene and safety of the pet throughout the entire journey.",
            ],
            "Pets weighing more than 8 kg are not accepted for carriage unless the Carrier has given prior and explicit approval for the specific journey.",
            "The Carrier reserves the right to refuse carriage of a pet where the requirements of this section are not met or where the animal creates a genuine safety risk or serious inconvenience to other passengers.",
            "For international travel, the owner bears full responsibility for ensuring that all necessary documents, pet passports, vaccinations, microchips and other requirements for travel through the relevant countries and border crossings are satisfied.",
          ],
        },
        {
          heading: "8. Travel by Children",
          content: [
            "Children under the age of 14 must travel with an accompanying adult.",
            "The parent, legal guardian or accompanying adult is responsible for ensuring that all documents, declarations and authorisations required for the child's journey are available, including for international travel.",
          ],
        },
        {
          heading: "9. Timetable, Route and Stops",
          content: [
            "Kaleia Ltd. makes reasonable efforts to operate in accordance with the published timetable.",
            "Published arrival times may be affected by road traffic, congestion, road accidents, border and customs checks, weather conditions, temporary road restrictions and other circumstances outside the immediate control of the Carrier.",
            "Where necessary and where justified by objective circumstances, the Carrier may temporarily change the route, boarding or drop-off point, or an intermediate stop.",
            "Where such a change is known in advance and is significant to the journey, the Carrier will make reasonable efforts to inform affected passengers in a timely manner through the contact details provided by them or through the company's information channels.",
            "Nothing in this section limits any rights granted to passengers under applicable law.",
          ],
        },
        {
          heading: "10. Cancellation or Significant Delay of a Service",
          content: [
            "Where a journey is cancelled or a significant delay in departure is expected, Kaleia Ltd. will inform affected passengers as soon as reasonably possible, provided that the Carrier has up-to-date contact details for them.",
            "Where required by applicable law, passengers will be offered a choice between:",
            [
              "continuation or rerouting to the final destination under comparable conditions and at the earliest opportunity; or",
              "reimbursement of the relevant ticket price.",
            ],
            "Where a coach becomes technically unserviceable during a journey, the Carrier will take the reasonable and legally required steps to continue the transport, provide a replacement vehicle or transport passengers to a location from which the journey may continue.",
            "Where applicable European or national legislation grants passengers additional rights to assistance, reimbursement or compensation in the event of cancellation or delay, those rights apply independently of these General Terms and Conditions.",
          ],
        },
        {
          heading: "11. Circumstances Outside the Carrier's Control",
          content: [
            "The Carrier cannot guarantee an exact arrival time where circumstances beyond its reasonable control occur, including heavy traffic, road accidents, road closures, border controls, strikes, severe weather conditions, natural disasters, actions of public authorities or other extraordinary circumstances.",
            "Where such circumstances arise, the Carrier will make reasonable efforts to minimise their impact on passengers.",
            "Nothing in this section excludes or limits any rights which may not legally be excluded or limited under applicable law.",
          ],
        },
        {
          heading: "12. Passengers with Disabilities or Reduced Mobility",
          content: [
            "Kaleia Ltd. does not discriminate against passengers on the grounds of disability or reduced mobility.",
            "Passengers requiring special assistance should notify the Carrier in advance and within a reasonable period before travel so that appropriate arrangements may be made, where possible.",
            "The Carrier will provide assistance in accordance with applicable law, the technical characteristics of the vehicle used and the specific circumstances of the journey.",
          ],
        },
        {
          heading: "13. Lost and Forgotten Property",
          content: [
            "Passengers are responsible for taking reasonable care of their personal belongings during the journey and when leaving the coach.",
            "Where an item has been left behind, the passenger should contact Kaleia Ltd. as soon as possible and provide:",
            [
              "the date and route of travel;",
              "the ticket number or other ticket details, where available;",
              "a detailed description of the lost item;",
              "contact details for follow-up.",
            ],
            "Found property will be retained by the Carrier for a reasonable period, depending on its nature and the applicable requirements.",
            "Any costs associated with shipping or returning found property outside the usual collection location may be borne by the owner of the item.",
          ],
        },
        {
          heading: "14. Complaints, Reports and Claims",
          content: [
            "Passengers may submit complaints, reports and claims relating to transport services provided by Kaleia Ltd. by email to:",
            "office@kaleiatravel.com",
            "The complaint should contain sufficient information to identify the relevant journey and the issue concerned, including the date, route, ticket details and contact information, where available.",
            "For cases falling within the scope of Regulation (EU) No 181/2011, a complaint concerning rights under the Regulation may be submitted within three months from the date on which the regular service was performed or should have been performed.",
            "Kaleia Ltd. will review complaints and provide a response within the time limits established by applicable law.",
          ],
        },
        {
          heading: "15. Safety During Travel",
          content: [
            "Passengers are required to comply with all instructions given by the driver or representatives of the Carrier relating to safety during the journey.",
            "Where the coach is equipped with seat belts, passengers must use them in accordance with applicable legal requirements.",
            "Passengers must not behave in a manner that may distract the driver, interfere with the safe operation of the vehicle or create a risk to other passengers.",
            "Aisles, doors and emergency exits must not be obstructed.",
          ],
        },
        {
          heading: "16. Applicable Law and Passenger Rights",
          content: [
            "These General Terms and Conditions apply together with the applicable Bulgarian and European legislation governing passenger road transport and consumer protection.",
            "Where any provision of these General Terms and Conditions conflicts with a mandatory provision of applicable law, the mandatory legal provision shall prevail.",
            "These General Terms and Conditions do not restrict any statutory rights of passengers which cannot legally be waived or limited by contract.",
            "By purchasing a ticket, the passenger confirms that they have had the opportunity to review these General Terms and Conditions.",
            "By using the transport service, the passenger agrees to comply with the applicable safety and conduct rules during the journey.",
          ],
        },
      ],
      policyPrivacyHeading:
        'This privacy policy describes how "Kalea" OOD, with registered office in Sofia, 5A Struga Street, a licensed operator holding a License for International Passenger Transport with number 0005, collects, uses and protects the personal data of users of our bus ticket sales system. We are committed to protecting your personal information and complying with the General Data Protection Regulation (GDPR).',
      policyPrivacyFirstHeading: "1. Information collection",
      policyPrivacyFirstDescription:
        "We collect the following information: First name Last name Email address Phone number Payment information (for transaction purposes only) Travel information (date, time, destination)",
      policyPrivacySecondHeading: "2. Legal basis for processing",
      policyPrivacySecondDescription:
        "We process your personal data on the following grounds: Performance of a contract Legal obligation Legitimate interest Your consent",
      policyPrivacyThirdHeading: "3. Use of information",
      policyPrivacyThirdDescription:
        "The information collected is used to: Process purchases and reservations Send confirmations and updates Improve our services Customer service",
      policyPrivacyFourHeading: "4. Sharing information",
      policyPrivacyFourDescription:
        "We do not share users' personal data with third parties unless necessary to: Process payment transactions Comply with legal requirements Protect our rights and property",
      policyPrivacyFiveHeading: "5. Information protection",
      policyPrivacyFiveDescription:
        "We use a variety of security measures to ensure the protection of personal data, including: Data encryption Limited access to data Regular checks of security systems",
      policyPrivacySixHeading: "6. Consumer rights",
      policyPrivacySixDescription:
        "Users have the right to: Access their personal data Rectify their personal data Erase their personal data (right to be forgotten) Restrict the processing of their personal data Data portability Object to data processing Opt out of automated decisions and profiling",
      policyPrivacySevenHeading: "7. Data retention",
      policyPrivacySevenDescription:
        "We retain personal data for as long as necessary to fulfill the purposes for which it was collected, including to comply with legal, accounting or reporting requirements.",
      policyPrivacyEightHeading: "8. Data transfer",
      policyPrivacyEightDescription:
        "Your personal data may be transferred to and stored outside the European Economic Area (EEA). In such cases, we will take all necessary measures to ensure an adequate level of protection.",
      policyPrivacyNineHeading: "9. Data Breach Notification",
      policyPrivacyNineDescription:
        "In the event of a personal data breach, we will notify the affected individuals and the competent authorities in accordance with the GDPR.",
      policyPrivacyTenHeading: "10. Contact",
      policyPrivacyTenDescription:
        "If you have any questions or concerns about this privacy policy, please contact us at: Email: office@kaleiatravel.com Phone: +359 894 77 44 40 +359 2 832 10 88",
      policyPrivacyElevenHeading: "11. Changes to the Privacy Policy",
      policyPrivacyElevenDescription:
        "We reserve the right to update this privacy policy at any time. Changes will be posted on our website and will be effective immediately upon their posting.",
      remove: "Remove",
      expireTicketsInCart:
        "Your tickets have expired. Please add them again to complete your purchase.",
      pleaseSelectOtherDateTwoWay: "Please choose a different return date.",
      emptyInputs: "Empty Fields",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "bg", // Default language
  fallbackLng: "en",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
